import React from 'react'
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts'
import styles from './MicrositeBarChart.module.css'

/**
 * MicrositeBarChart
 * Recharts BarChart wrapper with consistent CRM styling — used for
 * "views by date" on MicrositeAnalytics and "events by type" on
 * MicrositeConversions.
 *
 * Usage:
 *   <MicrositeBarChart
 *     data={viewStats.data}
 *     xKey="groupKey"
 *     yKey="totalViews"
 *     height={220}
 *   />
 */
const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload?.length) return null
    return (
        <div className={styles.tooltip}>
            <div className={styles.tooltipLabel}>{label}</div>
            {payload.map((p) => (
                <div key={p.dataKey} className={styles.tooltipValue}>
                    {p.value}
                </div>
            ))}
        </div>
    )
}

const MicrositeBarChart = ({ data = [], xKey, yKey, height = 220, barColor = '#0369a1' }) => {
    if (!data.length) {
        return <div className={styles.empty}>No data for this period yet</div>
    }

    return (
        <div className={styles.wrap} style={{ height }}>
            <ResponsiveContainer width="100%" height="100%">
                <BarChart data={data} margin={{ top: 4, right: 4, left: -16, bottom: 0 }}>
                    <CartesianGrid vertical={false} stroke="#eef0f2" />
                    <XAxis
                        dataKey={xKey}
                        tick={{ fontSize: 11, fill: '#9aa1ac' }}
                        axisLine={{ stroke: '#e6e8eb' }}
                        tickLine={false}
                    />
                    <YAxis
                        tick={{ fontSize: 11, fill: '#9aa1ac' }}
                        axisLine={false}
                        tickLine={false}
                        width={36}
                    />
                    <Tooltip content={<CustomTooltip />} cursor={{ fill: '#f6f7f9' }} />
                    <Bar dataKey={yKey} fill={barColor} radius={[4, 4, 0, 0]} maxBarSize={36} />
                </BarChart>
            </ResponsiveContainer>
        </div>
    )
}

export default MicrositeBarChart